import React from 'react';

class SeriesDetailsOverview extends React.Component {
  render() {
    let { series } = this.props;
    return (
      <div className="series-overview">
        <div>
          <label>Series Name</label>
          <span>{series && series.name}</span>
        </div>
        <div>
          <label>Number of Exercises</label>
          <span>{series && series.exerciseCollection && series.exerciseCollection.length}</span>
        </div>
        <div>
          <label>Reps</label>
          <span>
            {series &&
              (series.is_custom_reps ? series.reps : series.method)}
          </span>
        </div>
        <div>
          <label>Sets</label>
          <span>{series && series.sets}</span>
        </div>
      </div>
    );
  }
}

export default SeriesDetailsOverview;
